import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, CircleDot } from 'lucide-react';
import { T, springs } from '../../lib/tokens';
import { Glass } from '../glass/Glass';

export const FounderCard = ({ founder, meetingCount, openActions, lastMeeting, onClick }) => {
  const initials = founder.name
    .split(' ')
    .map(w => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();

  return (
    <Glass depth={1} tint="blue" hover onClick={onClick} style={{ padding: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
        <div style={{
          width: 40, height: 40, borderRadius: 12,
          background: T.blueLight, color: T.blue,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          fontSize: 14, fontWeight: 700, flexShrink: 0,
        }}>
          {initials}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontSize: 14, fontWeight: 600, color: T.text }}>{founder.name}</div>
          {founder.company_name && (
            <div style={{ fontSize: 11, color: T.textMuted, marginTop: 1 }}>{founder.company_name}</div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, fontSize: 11, color: T.textMuted }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          <Calendar size={11} />
          <span>{meetingCount} meeting{meetingCount !== 1 ? 's' : ''}</span>
        </div>
        {openActions > 0 && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            <CircleDot size={11} color={T.amber} />
            <span style={{ color: T.amber, fontWeight: 600 }}>{openActions} open</span>
          </div>
        )}
      </div>

      {lastMeeting && (
        <div style={{ fontSize: 10, color: T.textLight, marginTop: 8 }}>
          Last: {new Date(lastMeeting).toLocaleDateString('en-GB', { day: 'numeric', month: 'short' })}
        </div>
      )}
    </Glass>
  );
};
